import { Component } from '@angular/core';
import {
  CesionarioSummaries,
  Proveedor,
  DateFilters,
  DashboardFilterViewModel,
  Clientes,
} from './interface/data.interface';
import { CompaniesFactoringService } from './services/companies-factoring.service';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { delay, finalize } from 'rxjs';
import { CompaniesService } from './services/companies.service';
import { PushNotificationService } from 'src/app/services/push-notification.service';

@Component({
  selector: 'app-factoring',
  templateUrl: './factoring.component.html',
  styleUrls: ['./factoring.component.scss'],
})
export class FactoringComponent {
  sendDateFilter: DateFilters;
  proveedorCompany: Proveedor;
  clientes: PageResult<Clientes>;

  cesionarioSummaries: CesionarioSummaries;
  panelOpenState = false;
  providerSummaries: PageResult<Proveedor>;
  booleanFlag: boolean = false;
  booleanFlagCesionario: boolean = false;
  booleanText: boolean = false;

  public dashboardFilter: DashboardFilterViewModel;

  constructor(
    private companies: CompaniesFactoringService,
    private company: CompaniesService,
    private pushNotificationService: PushNotificationService
  ) {
    this.providerSummaries = {
      ...this.providerSummaries,
      results: [],
    };
    this.clientes = {
      ...this.clientes,
      results: [],
    };

    //Hace la cuenta desde hoy hace 3 meses atras
    const currentDate = new Date();
    /*const twelveMonthsAgo = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - 6,
      1
    ).toISOString();*/

    const ultimoDia = new Date(currentDate).toISOString();
    const primerDia = new Date('1900-01-01').toISOString();

    /*const ultimoDia = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      0
    ).toISOString();*/

    this.dashboardFilter = {
      ...this.dashboardFilter,
      startDate: primerDia,
      endDate: ultimoDia,
      page: 1,
      size: 10,
      search: '',
      sii: null,
      isPyme: false,
      sortOrder: ''
    };
  }

  ngOnInit(): void {
    this.getAllCompanies();
        // <!-- PushAlert -->
    // <script type="text/javascript">
    // (function(d, t) {
    //   var g = d.createElement(t) as HTMLScriptElement,
    //   s = d.getElementsByTagName(t)[0];
    //   g.src = "https://cdn.pushalert.co/integrate_cf04e4cec7122f33155fbefb347f06ba.js";
    //   s.parentNode.insertBefore(g, s);
    // }(document, "script"));
    // </script>
    // <!-- End PushAlert -->
  }

  /**
   * Metodo para recibir evento de cambio de filtro de fecha de inicio y termino de consulta de empresas proveedores y cesionarias
   * @param event Nuevas fechas de inicio y termino seleccionadas en filtro
   */
  receiveFilterDate(event: DateFilters) {
    const { dateStart, dateEnd } = event;
    this.dashboardFilter = {
      ...this.dashboardFilter,
      startDate: dateStart,
      endDate: dateEnd,
    };

    this.getAllCompanies();
  }

  receiveChangeSortingOrder(sortOrder: string) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      sortOrder: sortOrder
    }
    this.getAllCompanies();
  }

  //Filtro por Nombre
  async receiveFilterCompany(event: string) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      search: event,
    };

    this.getAllCompanies();
  }

  /**
   * Metodo para recibir evento de cambio de paginacion de tabla de proveedores (tamanio y pagina seleccionada)
   * @param changePagination Parametros de paginacion seleccionadas en tabla de proveedores (page: Pagina, Size: N° de registro de pagina)
   *
   */
  public receiveProviderPaginationChange(changePagination: any) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      page: changePagination.page,
      size: changePagination.size,
    };

    this.getAllCompanies();
  }
  public receiveChangePymeFilter(event: boolean | null) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      isPyme: event,
    };
    if (this.dashboardFilter.isPyme == null) {
      this.dashboardFilter = {
        ...this.dashboardFilter,
        isPyme: event,
      };
    }
    this.getAllCompanies();

  }
  /**
   * Metodo para recibir cambio en filtro de enrolamiento de clave SII
   * @param event Nuevo valor seleccionado en filtro
   */
  public receiveChangeSiiFilter(event: boolean | null) {
    this.dashboardFilter = {
      ...this.dashboardFilter,
      sii: event,
    };

    this.getAllCompanies();
  }

  public getAllCompanies() {
    const { startDate, endDate, search, page, size, sii, isPyme, sortOrder } =
      this.dashboardFilter;
    this.booleanFlag = true
    this.booleanText = true
    this.company
      .getAllCompanies(startDate, endDate, page, search, size, sii, isPyme, sortOrder)
      .pipe(
        delay(1500),
        finalize(() => { this.booleanFlag = false }),
      )
      .subscribe({
        next: (response) => {
          if (response.results.length == 0) {
            this.booleanText = false
          }
          this.clientes = response;
          this.booleanFlag = false
        },
        error: (e) => {
          //que ocurre cuando hay un error
          console.log(e)
        },
        complete: () => {
          this.booleanFlag = true

        }
      });
  }
}
